import { domainPath } from '../App';
import { searchDClient, dynamicSearchDetails } from '../api/api';

export class KeyUpService {
    static handleKeyUp = async (eventValue, state, data, configType, subConfigType, updateLocalState) => {
         const { name, value } = eventValue;
        const { client_form, isEdit } = state;
        const isAccessToken = state.user?.user?.accessToken || '';

        if (isEdit !== 'true') {
           
            if (['perseus-house'].includes(domainPath)) {
                if (data.question === 'Date of Birth' && value !== "") {
                     updateLocalState({isLoading: true});
                     let payLoad = {"First Name": client_form["First Name"],"Last Name":client_form["Last Name"]}
                   let response = await dynamicSearchDetails(payLoad, isAccessToken, configType, subConfigType, true);
                    if (response?.data && response?.data?.length > 0) {
                        updateLocalState({isLoading: false});
                        alert( 
                            `Client Code already exists. Data will not save if you continue. Please use the existing client search to update any existing client data.`
                        );
                    }
                }
                
            } else {
                if (data?.is_primary_key) {
                    let clientCode = data.answer;
                    
                    if(value !== ""){
                        let response:any = [];
                         updateLocalState({isLoading: true});
                        response = await dynamicSearchDetails({ [data.question]: value }, isAccessToken, configType, subConfigType, true);
                        updateLocalState({isLoading: false});
                        if (response?.data && response?.data?.length > 0) {
                           alert(
                           `${data.question} already exists. Data will not save if you continue. Please use the existing client search to update any existing client data.`
                           )
                       }
                    }
                     
                }
            }
        }
    };

   static getConfSubConf = (locationDetails) => {
    let indexOfUrl = locationDetails.indexOf('config');
        if(indexOfUrl > 0 && indexOfUrl !== -1){
            locationDetails =  locationDetails.slice(indexOfUrl)
        }
        const params = new URLSearchParams(locationDetails);
        const Config: any = params.get('config');
        const subConfig: any = params.get('subConfig');
        const index: any = params.get('index');
        const isEdit: any = params.get('isEdit');
        const Rerefer: any = params.get('Rerefer');
       
        return {Config: Config, subConfig: subConfig, index:index, isEdit:isEdit, Rerefer:Rerefer}
    }
}